import { ChangeDetectionStrategy, Component, EventEmitter, HostBinding, Input, Output } from '@angular/core';
import { LinkedEntitiesGroup, LinkedEntity } from '../../types';
import { ButtonType } from '@anecdotes/design-system/buttons';

export enum LinkedEntitiesLabelTypes {
  Blue = 'blue',
  UnderlinedText = 'underlined-text',
  Gray = 'gray',
  Blank = 'blank'
}

@Component({
  selector: 'app-linked-entities',
  templateUrl: './linked-entities.component.html',
  styleUrls: ['./linked-entities.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LinkedEntitiesComponent {
  private _linkedEntitiesGroups: LinkedEntitiesGroup[];
  private _overallEntitiesCount: number;

  @HostBinding('class.hidden')
  private get shouldBeHidden(): boolean {
    if (this.displayOnDemand) {
      return false;
    }
    return !(this.linkedEntitiesGroups?.length && this.overallEntitiesCount);
  }

  get linkedEntitiesGroups(): LinkedEntitiesGroup[] {
    return this._linkedEntitiesGroups;
  }

  @Input()
  set linkedEntitiesGroups(groups: LinkedEntitiesGroup[]) {
    this._linkedEntitiesGroups = groups;
    this._overallEntitiesCount = this.getOverallEntitiesCount();
  }

  @Input()
  displayOnDemand?: boolean;

  @Input()
  allowTooltip = true;

  @Input()
  textInLabel: string;

  @Input()
  textInTooltip: string;

  @Input()
  textTooltipNoLinks: string;

  @Input()
  textInLabelNoLinks: string;

  @Input()
  buttonType: ButtonType = 'secondary';

  @Input()
  labelIcon: string;

  @Input()
  labelIconClasses: string = 'label-icon';

  @HostBinding('class')
  @Input()
  labelType: LinkedEntitiesLabelTypes = LinkedEntitiesLabelTypes.Blue;

  @Input()
  tooltipClasses: string;

  @Output()
  linkClick = new EventEmitter<LinkedEntity>();

  get overallEntitiesCount(): number {
    return this._overallEntitiesCount;
  }

  private getOverallEntitiesCount(): number {
    return this.linkedEntitiesGroups?.reduce((result, group) => result + (group.entities?.length || 0), 0);
  }
}
